const Compare = () => {
  const compareContainers = document.querySelectorAll ( '.js-compare' )
  // const compareContainer = document.querySelector('.js-compare')
  if ( compareContainers.length ) {
    ;[...compareContainers].forEach ( ( compareContainer ) => {
      const compareClipper = compareContainer.querySelector ( '.js-compare-clipper' )
      
      const clippedComare = compareClipper.querySelector ( '.js-compare-item' )
      const bar = compareContainer.querySelector ( '.js-compare-bar' )

      const trackLocation = ( e ) => {
        const rect = compareContainer.getBoundingClientRect ( )
        let position = ( ( e.pageX - rect.left ) / compareContainer.offsetWidth ) * 100
        if ( e.type === 'touchmove' ) {
          position = ( ( e.touches[0].pageX - rect.left ) / compareContainer.offsetWidth ) * 100
        }

        if ( position <= 98 && position >= 2 ) {
          compareClipper.style.width = position + '%'
          clippedComare.style.width = ( ( 100 / position ) * 100 ) + '%'
          clippedComare.style.zIndex = 3
          bar.style.left = position + '%'
        }
      }

      if ( compareContainer ) {
        bar.addEventListener ( 'mousedown', ( e ) => {
          compareContainer.addEventListener ( 'mousemove', trackLocation, false )
          document.addEventListener ( 'mouseup', ( e ) => {
            compareContainer.removeEventListener ( 'mousemove', trackLocation, false )
          })
        })
        bar.addEventListener ( 'mouseup', ( e ) => {
          compareContainer.removeEventListener ( 'mousemove', trackLocation, false )
        })
        bar.addEventListener ( 'touchstart', ( e ) => {
          compareContainer.addEventListener ( 'touchmove', trackLocation, false )
          document.addEventListener ('touchend', ( e ) => {
            compareContainer.removeEventListener ( 'touchmove', trackLocation, false )
          })
        })
        bar.addEventListener ( 'touchend', ( e ) => {
          compareContainer.removeEventListener ( 'touchmove', trackLocation, false )
        })
      }
    })
  }
}

export default Compare



// WEBPACK FOOTER //
// ./src/js/modules/Compare.js